module.exports = __webpack_public_path__ + "img/dcb1.b23099cd.png";